import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PhConfigLoaderService } from '@frontend/common/ph-config-loader';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'frontend-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SuccessModalComponent implements OnDestroy {
  private _subscriptions: Subscription[] = [];

  constructor(private config: PhConfigLoaderService, private dialog: MatDialog) {
    const timeout = this.config.getConfig('SUCCESS_FLOW_REDIRECT_SEC') || 5;
    const timeoutMs = timeout * 1000;
    this._subscriptions.push(timer(timeoutMs).subscribe(() => this.dialog.closeAll()));
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }
}
